import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import * as Sentry from "@sentry/capacitor";
import * as SentryAngular from "@sentry/angular";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

// Initialize Sentry before bootstrapping Angular
Sentry.init(
  {
    release: `jeripass-customer-app@${environment.release}`,
    dsn: "https://zoWTDn5Pgqw19N5MLf8oVKAi@s1613592.eu-nbg-2.betterstackdata.com/1",
    environment: environment.name,
    attachStacktrace: true,
    enableAutoSessionTracking: true,
    enabled: ["staging", "production"].includes(environment.name),
    tracePropagationTargets: [environment.apiUrl],
    beforeSend: event => {
      if (!environment.production) console.error("[Sentry]", event);
      return event;
    },
  },
  SentryAngular.init,
);

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err));
